import { PrimitiveValueObject } from '@/domain/primitiveValueObject';

export class Category extends PrimitiveValueObject<string> {
  /**
   * 生成
   * @param value 値
   * @returns 生成値
   */
  static create(value: string): Category {
    if (!(value.length > 0)) {
      throw new Error('カテゴリが入力されていません');
    }
    return new Category(value);
  }

  /**
   * ラベル
   */
  static get label(): string {
    return 'カテゴリ';
  }

  /**
   * PlaceHolder
   */
  static get placeholder(): string {
    return 'カテゴリ';
  }

  /**
   * バリデーションルール
   */
  static get validationRule() {
    return {
      /** 必須 */
      required: '必須項目です',
    };
  }

  /**
   * キー
   */
  static get key(): string {
    return 'category';
  }

  /**
   * タイプ
   */
  static get type(): string {
    return 'text';
  }

  /**
   * 表示を返す
   * @returns 表示
   */
  override toString() {
    return this.value;
  }
}
